/* One cart-based shipping indicator for every PDP. No product/quantity/discount mutation. */
(() => {
  if (customElements.get('hc-cart-shipping')) return;
  customElements.define('hc-cart-shipping', class extends HTMLElement {
    connectedCallback() {
      this.cleanup = new AbortController();
      this.schedule = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 80);
      };
      this.render(Number(this.dataset.total), this.dataset.currency, this.dataset.cartHasPens === 'true');
      if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, this.schedule);
      }
      // Covers the existing quick-add implementation, which refreshes the drawer without publishing cartUpdate.
      const drawer = document.getElementById('Cart-Drawer');
      if (drawer) {
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(drawer, {childList:true, subtree:true});
      }
      for (const event of ['focus', 'pageshow']) window.addEventListener(event, this.schedule, {signal:this.cleanup.signal});
      this.schedule();
    }
    async refresh() {
      this.request?.abort();
      this.request = new AbortController();
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {cache:'no-store',signal:this.request.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        this.render(cart.total_price, cart.currency, cart.items.some(item => item.product_id === 15464026472770));
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.dataset.pensProduct === 'true') return;
        this.querySelector('[data-hc-message]').textContent = 'Refresh to check shipping';
        this.querySelector('[data-hc-cart]').textContent = 'Cart total unavailable';
        this.querySelector('progress').value = 0;
      }
    }
    render(total, currency, hasPens) {
      const isPensProduct = this.dataset.pensProduct === 'true';
      const showPensShipping = isPensProduct || hasPens;
      this.querySelector('[data-hc-promise-title]').textContent = showPensShipping ? 'Free standard shipping · No minimum spend' : 'US shipping: $8 · Free at $39 after discounts';
      this.querySelector('[data-hc-promise-detail]').textContent = isPensProduct ? '12 colors + 1 spoon included. During livestreams, $5 off is applied automatically at checkout — no code needed.' : hasPens ? 'Your order includes Floating Ink Pens and qualifies for free shipping.' : 'Estimated US delivery: about 14 business days.';
      this.querySelector('[data-hc-pens-shipping]').hidden = !showPensShipping;
      this.querySelector('[data-hc-general-shipping]').hidden = showPensShipping;
      this.querySelector('progress').hidden = showPensShipping;
      this.querySelector('progress').style.display = showPensShipping ? 'none' : '';

      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || 'USD'}).format(amount/100);
      const supported = currency === 'USD' && this.dataset.country === 'US';
      this.querySelector('[data-hc-cart]').textContent = `Cart after discounts: ${money(total)}`;
      this.querySelector('[data-hc-message]').textContent = hasPens ? 'Free shipping unlocked for your entire order' : isPensProduct ? 'This set ships free' : !supported ? 'US free shipping: $39 USD after discounts' : total >= 3900 ? 'US standard shipping is free' : `${money(3900-total)} more after discounts for free US shipping`;
      this.querySelector('progress').value = supported ? Math.max(0, Math.min(3900,total)) : 0;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);this.cleanup?.abort();this.request?.abort();this.unsubscribe?.();this.observer?.disconnect();
    }
  });
})();
